var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlayIcon = function SvgPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#playIcon_svg__a)",
    stroke: "#07818C",
    d: "M.5 19.3a1.5 1.5 0 0 0 2.228 1.312l14.941-8.3a1.5 1.5 0 0 0 0-2.623l-14.94-8.3A1.5 1.5 0 0 0 .5 2.698z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "playIcon_svg__a",
    x1: 10,
    x2: 10,
    y1: 1,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07818C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17D3E5"
  })))));
};
export default SvgPlayIcon;